

export const APIKEY_REQUEST = 'APIKEY_REQUEST';
export const APIKEY_DATA = 'APIKEY_DATA';
export const APIKEY_ERROR = 'APIKEY_ERROR';

export const APIKEY_DELETE_REQUEST = 'APIKEY_DELETE_REQUEST';
export const APIKEY_DELETE_DATA = 'APIKEY_DELETE_DATA';
export const APIKEY_DELETE_ERROR = 'APIKEY_DELETE_ERROR';